"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  goesOffline: {
    "id": "goesOffline",
    "defaultMessage": "You're offline. Check your internet connection."
  },
  goesBackOnline: {
    "id": "goesBackOnline",
    "defaultMessage": "You're back online!"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map